// extracted by mini-css-extract-plugin
export default {"bottom":"index_bottom_E45MQ"};